import { FiberManualRecord as ColorIndicatorIcon } from "@remo-co/ui-core/src/icons/FiberManualRecord";

interface Props {
  color: string;
}

export const ColorOptionIcon = ({ color }: Props) => (
  <ColorIndicatorIcon sx={{ color }} />
);
